import { sortAlphabetically } from '../lib/sorting';

import APIClient from './APIClient';

const {
  REACT_APP_ONBOARDING_API_HOST: ONBOARDING_API_HOST,
  REACT_APP_UNIVERSITIES_ENDPOINT: UNIVERSITIES_ENDPOINT,
} = process.env;

export const url = `${ONBOARDING_API_HOST}${UNIVERSITIES_ENDPOINT}`;

export default class UniversitiesAPI {
  static getUniversities = token =>
    APIClient.get(url, token).then(response => {
      const universities = response.data.map(({ name, id }) => ({
        value: id,
        label: name,
      }));
      return sortAlphabetically(universities, 'label');
    });
}
